angular.module('lf.common')

.factory('accountService', function ($http, $rootScope, $q, vindiciaService) {
  
  return {
    
    addOrUpdateCard: function (params) {
      var deferred = $q.defer();
      params = $.extend(true, {}, params);

      vindiciaService.initializeWebSession({ flow: params.flow })
        .success(function (response) {
          var data = response.data;
          if (data.success) {
            var webSessionId = data.webSessionId;
            // To have an access to these Vindicia fields you have to include in jsp:
            // <dsp:include page="../header.jsp">
            //   <dsp:param name="jsDataInline" value="creditCardFormData" />
            // ..
            var vidiciaParams = lf.data.creditCardFormData.vindiciaFormHiddenFieldValues;
            
            // Normalize form params between desktop & mobile version
            // until we'll have universal dropdown component
            var client = lf.data.xhr.client;
            if (client.isMobile) {
              params.expires.month = params.expires.month.value;
              params.expires.year = params.expires.year.value;
              params.billingAddress.state = params.billingAddress.state.value;
              if (params.billingAddress.country) {
                params.billingAddress.country = params.billingAddress.country.value;
              }
            }

            vindiciaService.addOrEditCreditCard({
              
              flow: params.flow, // default (account) or subscription
              updateCC: params.updateCC,
              editCreditCardVID: params.id,
              vinWebSessionMethod: vidiciaParams.vinWebSessionMethod, // 'PaymentMethod_Update',
              paymentMethodType: vidiciaParams.paymentMethodType,
              merchantAccountId: vidiciaParams.merchantAccountId,
              webSessionId: webSessionId || params.webSessionId || vidiciaParams.webSessionId,
              paymentMethodId: data.paymentMethodId,
              paymentCurrencyCode: vidiciaParams.paymentCurrencyCode,
              accountHolderName: params.name,
              creditCardNumber: params.number,
              creditCardExpirationMonth: params.expires.month,
              creditCardExpirationYear: params.expires.year,
              nameValueCvn: params.cvn,
              billingAddress1: params.billingAddress.address1,
              billingAddress2: params.billingAddress.address2,
              billingAddress3: params.billingAddress.address3,
              billingAddressCity: params.billingAddress.city,
              billingAddressState: params.billingAddress.state,
              billingAddressCountry: params.billingAddress.country || vidiciaParams.billingAddressCountry,
              billingAddressPostalCode: params.billingAddress.postalCode,
              billingPhone: params.billingAddress.phoneNumber,
              saveCreditCardInfo: params.saveCreditCardInfo || true,
              setAsDefaultCreditCard: params.setAsDefaultCreditCard || false

            }, function success (response) {
              var data = response.data;
              if (data.success) {
                deferred.resolve(data);
              } else {
                deferred.reject(data.error);
                console.error('vindiciaService.addOrEditCreditCard success: false', arguments);
              }
            }, function error (response) {
              var data = response && response.data;
              if (data && data.error) {
                deferred.reject(data.error);
              } else {
                deferred.reject({
                  type: 'VINDICIA_ERROR',
                  message: 'vindiciaService.addOrEditCreditCard error'
                });
              }
              console.error('vindiciaService.addOrEditCreditCard error', arguments);
            });
          } else {
            deferred.reject({
              type: 'VINDICIA_ERROR',
              message: 'vindiciaService.initializeWebSession success: false'
            });
            console.error('vindiciaService.initializeWebSession success: false', arguments);
          }
        })
        .error(function () {
          deferred.reject({
            type: 'SERVER_ERROR', 
            message: 'vindiciaService.initializeWebSession server error'
          });
          console.error('vindiciaService.initializeWebSession server error', arguments);
        });
        
      return deferred.promise;
    },
    
    deleteCreditCard: function (params) {
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        data: $.param({
          // all ATG fields here + product specific
          deleteCreditCardID: params.creditCardId,
          getData: 'savedPaymentInfo',
          updateData: 'true',
          action: 'deleteCreditCard',
          amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('account:creditcards:update', data.data.savedPaymentInfo.creditCards);
        });
    },
      
    setCreditCardAsDefault: function (params) {
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        data: $.param({
          defaultCreditCardID: params.creditCardId,
          getData: 'savedPaymentInfo',
          updateData: 'true',
          action: 'setDefaultVindiciaCard',
          amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('account:creditcards:update', data.data.savedPaymentInfo.creditCards);
        });
    },
    
    resetPassword: function (params) {
      var postParams = {
        getData: 'resetPasswordResponse',
        updateData: 'true',
        action: 'forgotPassword',
        amplifiHandler: '/atg/userprofiling/ProfileFormHandler'
      };
      postParams['atg_lfResetPasswordForm.data.email.value'] = params.email;
      
      return $http({
        method: 'POST',
        url: lf.data.xhr.shopAction,
        data: $.param(postParams),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .success(function (data) {
          $rootScope.$broadcast('account:password:reset');
        });
    }
  };
});
